// @ts-ignore
import attentionBellSound from "./attention-bell-ding.wav"

const PAGE_TITLE = `${
  document.location.hostname === "localhost" ? "LOCAL " : ""
}InSoft Omni`
/**
 * @param {number} counter
 */
export function setNotificationForDocumentTitle(counter: number) {
  document.title = counter > 0 ? `(${counter}) - ${PAGE_TITLE}` : PAGE_TITLE
}

const notificationAudioController = new Audio(attentionBellSound)

export async function warnAgent(
  notificationCounter: number,
  config?: { silent: boolean }
) {
  if (notificationCounter > 0 && (!config || !config.silent)) {
    await notificationAudioController.play()
  }
  setNotificationForDocumentTitle(notificationCounter)
}

export const routerBaseSubpath = (): string => {
  /* console.log(
    "process.env.REACT_APP_REAL_SUBPATH",
    process.env.REACT_APP_REAL_SUBPATH
  ); */

  const subPath = process.env.REACT_APP_REAL_SUBPATH

  if (!subPath) {
    return "omni"
  }
  return subPath.substring(0, subPath.length - 1)
}
